import React from 'react';
import { ICellRendererParams } from '@ag-grid-community/core';
import BaseTypography from 'src/components/Text/BaseTypography';

export const TextCellRenderer: React.FC<ICellRendererParams> = React.memo(
  cellData => (
    <BaseTypography>{cellData.valueFormatted || cellData.value}</BaseTypography>
  ),
);
